import axios from "axios";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../store/authMethods";
import store from "../store/index";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 60000,
  retry: 1,
  retryDelay: 1000,
  // headers: {
  //   "Content-type": "application/json",
  // }
});

API.interceptors.request.use(
  function (config) {
    //console.log(config, "config");
    const token = localStorage.getItem("token");
    config.headers.Authorization = token ? `Bearer ${token}` : "";
    return config;
  },
  function (error) {
   // console.log(error, "error");
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
API.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    // Unauthorized
    //console.log(error, "error");
    if (error.response?.status === 401) {
      store.dispatch(logout());
      setTimeout(() => {
        // navigate("/");
        // window.location.href = "?action=login";
        window.location.href = `${window.location.origin}${window.location.pathname}?action=login`;
      }, 1500);

      // store.dispatch(setMessage(error.response.data.Message));
      // setTimeout(() => {
      //   store.dispatch(logoutUser());
      // }, 3000);
    }
    // if (error.response?.status === 500) {
    //   // store.dispatch(logout());
    //   setTimeout(() => {
    //     // navigate("/");
    //     window.location.href = "?action=login";
    //   }, 1000);
    // }

    return Promise.reject(error);
  }
);

export default API;
// export async function getSingleQuote(params) {
//   const response = await API.get(`notices/show/${noticeId}`, params);
//   const data = await response.json();

//   if (!response.ok) {
//     throw new Error(data.message || "Could not fetch quote.");
//   }

//   const loadedQuote = {
//     id: noticeId,
//     ...data,
//   };

//   return loadedQuote;
// }

// export async function getAllQuotes() {
//   const response = await axios.get(`${FIREBASE_DOMAIN}/quotes.json`);
//   const data = await response.json();

//   if (!response.ok) {
//     throw new Error(data.message || "Could not fetch quotes.");
//   }

//   const transformedQuotes = [];

//   for (const key in data) {
//     const quoteObj = {
//       id: key,
//       ...data[key],
//     };

//     transformedQuotes.push(quoteObj);
//   }

//   return transformedQuotes;
// }

// export async function getSingleQuote(quoteId) {
//   const response = await fetch(`${FIREBASE_DOMAIN}/quotes/${quoteId}.json`);
//   const data = await response.json();

//   if (!response.ok) {
//     throw new Error(data.message || "Could not fetch quote.");
//   }

//   const loadedQuote = {
//     id: quoteId,
//     ...data,
//   };

//   return loadedQuote;
// }

// export async function addQuote(quoteData) {
//   const response = await fetch(`${FIREBASE_DOMAIN}/quotes.json`, {
//     method: "POST",
//     body: JSON.stringify(quoteData),
//     headers: {
//       "Content-Type": "application/json",
//     },
//   });
//   const data = await response.json();

//   if (!response.ok) {
//     throw new Error(data.message || "Could not create quote.");
//   }

//   return null;
// }

// export async function addComment(requestData) {
//   const response = await fetch(
//     `${FIREBASE_DOMAIN}/comments/${requestData.quoteId}.json`,
//     {
//       method: "POST",
//       body: JSON.stringify(requestData.commentData),
//       headers: {
//         "Content-Type": "application/json",
//       },
//     }
//   );
//   const data = await response.json();

//   if (!response.ok) {
//     throw new Error(data.message || "Could not add comment.");
//   }

//   return { commentId: data.name };
// }

// export async function getAllComments(quoteId) {
//   const response = await fetch(`${FIREBASE_DOMAIN}/comments/${quoteId}.json`);

//   const data = await response.json();

//   if (!response.ok) {
//     throw new Error(data.message || "Could not get comments.");
//   }

//   const transformedComments = [];

//   for (const key in data) {
//     const commentObj = {
//       id: key,
//       ...data[key],
//     };

//     transformedComments.push(commentObj);
//   }

//   return transformedComments;
// }
